import { useState } from 'react';
import { Smartphone, CreditCard, MoreVertical, Edit, Trash2, Star } from 'lucide-react';

export default function PaymentMethodCard({ method, onEdit, onDelete, onSetDefault }) {
  const [showActionMenu, setShowActionMenu] = useState(false);

  return (
    <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
      <div className="flex items-center space-x-3">
        <div className="flex justify-center items-center w-10 h-10 bg-emerald-100 rounded-full">
          {method.type === 'Mobile Money' ? <Smartphone size={20} className="text-emerald-600" /> : <CreditCard size={20} className="text-emerald-600" />}
        </div>
        <div>
          <p className="text-sm font-medium text-gray-900">{method.walletName || method.provider}</p>
          <p className="text-xs text-gray-500">{method.number}</p>
          {method.walletName && (
            <p className="text-xs text-gray-400">{method.provider}</p>
          )}
        </div>
      </div>
      
      <div className="flex gap-2 items-center">
        {method.isDefault && (
          <span className="px-2 py-1 text-xs font-medium text-emerald-700 bg-emerald-50 rounded-full border border-emerald-200">
            Default
          </span>
        )}
        <span className={`px-2 py-1 text-xs font-medium rounded-full border ${
          method.status === 'active' 
            ? 'text-emerald-700 bg-emerald-50 border-emerald-200' 
            : 'text-amber-700 bg-amber-50 border-amber-200'
        }`}>
          {method.status === 'active' ? 'Active' : 'Pending'}
        </span>
        
        {/* Action Menu */}
        <div className="relative">
          <button
            onClick={(e) => {
              e.stopPropagation();
              setShowActionMenu(!showActionMenu);
            }}
            className="p-1 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <MoreVertical size={16} />
          </button>
          
          {showActionMenu && (
            <div className="absolute right-0 top-8 z-[9998] py-2 w-48 bg-white rounded-lg border border-gray-200 shadow-lg">
              {!method.isDefault && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onSetDefault(method.id);
                    setShowActionMenu(false);
                  }}
                  className="flex gap-2 items-center px-4 py-2 w-full text-sm text-gray-700 transition-colors hover:bg-gray-50"
                >
                  <Star size={16} className="text-yellow-500" />
                  Set as Default
                </button>
              )}
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit(method);
                  setShowActionMenu(false);
                }}
                className="flex gap-2 items-center px-4 py-2 w-full text-sm text-gray-700 transition-colors hover:bg-gray-50"
              >
                  <Edit size={16} className="text-blue-500" />
                  Edit
                </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(method);
                  setShowActionMenu(false);
                }}
                className="flex gap-2 items-center px-4 py-2 w-full text-sm text-red-600 transition-colors hover:bg-red-50"
              >
                <Trash2 size={16} />
                Delete
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Click outside to close action menu */}
      {showActionMenu && (
        <div 
          className="fixed inset-0 z-[9997]" 
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setShowActionMenu(false);
            }
          }}
        />
      )}
    </div>
  );
}
